'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapVisibilityCallback = wrapVisibilityCallback;

var _isHidden = require('./isHidden');

function wrapVisibilityCallback(callback) {
  return function (_ref) {
    var _ref$hidden = _ref.hidden,
        hidden = _ref$hidden === undefined ? (0, _isHidden.isHidden)() : _ref$hidden;

    callback({ isVisible: !hidden });
  };
}